import { Component, OnInit } from '@angular/core';
import { PaginationInstance } from 'ngx-pagination';
import { Contract } from '../../models/interface-contract';
import { PrivateAreaService } from '../../services/private-area.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-historic-contracts',
    templateUrl: './historic-contracts.component.html',
    styleUrls: ['./historic-contracts.component.scss']
})

export class HistoricContractsComponent implements OnInit {

    contractsHistorical: Contract[];
    showLoader: boolean;
    errormessage = '';
    paginatorConfig: PaginationInstance;

    constructor(private privateAreaService: PrivateAreaService, private router: Router) {
        this.paginatorConfig = {
            itemsPerPage: 4,
            currentPage: 1,
            id: 'paginator-contracts-historical'
        };
    }

    ngOnInit(): void {
        this.privateAreaService.getAllContracts().subscribe(res => {
            this.contractsHistorical = res;
           // console.log(this.contractsHistorical);
            this.contractsHistorical = this.contractsHistorical.filter( contract => {
                return contract.vigente === false;
            });
           // console.log('HISTORIC CONTRACTS: ', this.contractsHistorical);
            if (res.length === 0) {
                this.errormessage = 'No existen históricos de contratos para este cliente.';
            }
        }, error => {
            this.showLoader = false;
            this.errormessage = 'Algo ha fallado, inténtalo más tarde.';
        });
    }

    navigateToContract(id) {
        this.router.navigateByUrl(`/contratos/${id}`);
    }
}
